export const isShowVideoStreamStats = (value: unknown): boolean => value === true
